import { TranslationsContext } from '@teliaee/telia-translate';
import React from 'react';
import { Card, CardContent, Separator, Table, TableCell, TableRow, Text } from 'telia-front-react';
import { replaceDotsAndFormatToTwoDecimalPlacesRoundingUp } from '../util/PriceUtil';
import { Prices } from './MeluCalculator';
import { resolveAverageDevicePrice, resolveTotalPrice } from './MeluDataUtil';
import { observer } from 'mobx-react';

interface Props {
  internetDeviceCount: number;
  callsDeviceCount: number;
  internetDataAmount: number;
  prices?: Prices;
}

const MeluSummaryTable = (props: Props): JSX.Element => {
  return (
    <Card background="brand-secondary-bg-subtlest">
      <CardContent>
        <Text>
          <Table>
            <tbody>{singleItemRow(props)}</tbody>
          </Table>
          <Separator />
          <Table>
            <tbody>{totalRow(props)}</tbody>
          </Table>
        </Text>
      </CardContent>
    </Card>
  );
};

const singleItemRow = (props: Props) => {
  const calculationProps = {
    internetDeviceCount: props.internetDeviceCount,
    callsDeviceCount: props.callsDeviceCount,
    internetDataAmount: props.internetDataAmount,
    prices: props.prices,
  };
  const { translate } = React.useContext(TranslationsContext);

  return (
    <TableRow>
      <TableCell className="h5">{translate('meluCalculator.summaryTable.averageDeviceCost')}</TableCell>
      <TableCell className="text-right">
        <span className="h2 text-bold">{replaceDotsAndFormatToTwoDecimalPlacesRoundingUp(resolveAverageDevicePrice(calculationProps))}</span>
        &nbsp;
        <span className="h4">{translate('meluCalculator.summaryTable.eurosPerMonth')}</span>
      </TableCell>
    </TableRow>
  );
};

const totalRow = (props: Props) => {
  const calculationProps = {
    internetDeviceCount: props.internetDeviceCount,
    callsDeviceCount: props.callsDeviceCount,
    internetDataAmount: props.internetDataAmount,
    prices: props.prices,
  };
  const { translate } = React.useContext(TranslationsContext);

  return (
    <TableRow>
      <TableCell className="h5">
        {translate('meluCalculator.summaryTable.totalSum', {
          deviceCount: props.internetDeviceCount || 1,
        })}
      </TableCell>
      <TableCell className="text-right text-bold">
        <span>{replaceDotsAndFormatToTwoDecimalPlacesRoundingUp(resolveTotalPrice(calculationProps))}</span>
        &nbsp;
        <span>{translate('meluCalculator.summaryTable.eurosPerMonth')}</span>
      </TableCell>
    </TableRow>
  );
};

export default observer(MeluSummaryTable);
